export default __webpack_public_path__ + "static/partner11-05bd6a17ad7f3282fd8b92c6731e87e8.png";